import { useQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import type { AccreditationStandard } from '../../_types/awb';

export async function getStandard(
  accreditationBodyId: string,
  versionId: string,
  standardId: string
): Promise<AccreditationStandard> {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/standards/${standardId}`;
  const data = await fetcher({
    method: 'get',
    url,
  });
  return data;
}

export default function useAccreditationStandardById(
  accreditationBodyId: string,
  versionId: string,
  standardId: string,
  enabled?: boolean,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<AccreditationStandard, Error>(
    ['accreditation_standard', accreditationBodyId, versionId, standardId],
    () => getStandard(accreditationBodyId, versionId, standardId),
    {
      ...options,
      enabled: enabled !== undefined ? enabled : !!versionId,
    }
  );
}
